var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import ImageTile from '../ImageTile';
function PageTile(_a) {
    var image = _a.image, label = _a.label, _b = _a.outline, outline = _b === void 0 ? false : _b, _c = _a.fontColor, fontColor = _c === void 0 ? 'bone' : _c, _d = _a.theme, theme = _d === void 0 ? 'dark' : _d, _e = _a.useHoverOverlay, useHoverOverlay = _e === void 0 ? false : _e, _f = _a.imageStyles, imageStyles = _f === void 0 ? '' : _f;
    return (_jsx(ImageTile, __assign({ image: image, outline: outline, theme: theme, useHoverOverlay: useHoverOverlay, imageStyles: imageStyles, className: "w-[276px] h-[276px] overflow-hidden" }, { children: _jsx("div", __assign({ className: "flex flex-col justify-end py-xs-m px-md-m w-full h-full" }, { children: _jsx("div", __assign({ className: "max-w-[105px]" }, { children: _jsx(Heading, __assign({ size: "sm", className: "uppercase text-".concat(fontColor) }, { children: label })) })) })) })));
}
export default PageTile;
